<div *ngIf="$selectTypeOfAnalysis | async">
    <ng-container *ngIf="$isTemplateAnalysis | async"></ng-container>
    <ng-container *ngIf="$isReadMode | async"></ng-container>
    <ng-container *ngIf="$selectedAnalysisPage | async"></ng-container>
    <ng-container *ngIf="$selectAppFeatures | async"></ng-container>
    <ng-container>
        <div class="old-footer-criterion-bar">
            <sera-ri-shi
                *ngFor="let criterionBarData of $criterionBarItems | async"
                styleClass="old-sera-ri-shi disable-selection footer-bar-ri-shi"
                [label]="criterionBarData.label"
                [color]="criterionBarData.trafficLightColor"
                [hideValue]="true"
                (click)="navigateCriterion(criterionBarData.criterion)"
                (keydown)="navigateCriterion(criterionBarData.criterion)">
            </sera-ri-shi>
        </div>
    </ng-container>
</div>
